








































































import { computed, defineComponent } from '@vue/composition-api';
import { useRoute } from '@ideavivat/vivat-2';
import { useQuery, useResult } from '@vue/apollo-composable';

import useSisahygo, { DEFAULT_SISAHYGO_SHIPMENT } from '@/useSisahygo';
import getSisahygoShipment from '@/gql/sisahygo/getSisahygoShipment.gql';

const SisahygoInformation = defineComponent({
  setup() {
    const route = useRoute();
    const trackingNo = route.params.tracking_no;
    const { statusClassMap } = useSisahygo();

    /* eslint-disable */
    const { result, loading, error: queryError } = useQuery(getSisahygoShipment, { tracking_no: trackingNo });

    const shipment = useResult(result, DEFAULT_SISAHYGO_SHIPMENT, (data: any) => data.sisahygoShipment);

    const error = computed(() => {
      if (queryError.value) return queryError.value.message;
      if (result.value?.errors?.length) return result.value.errors[0].message;
      return null;
    });

    function formatDate(val: string) {
      return val ? val.substring(0, 10) : '-';
    }

    function formatDateTime(val: string) {
      if (!val) return '-';
      try {
        return new Date(val).toLocaleString('th-TH', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        });
      } catch {
        return val;
      }
    }

    function formatAmount(val: number) {
      return val.toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    return {
      loading,
      error,
      shipment,
      statusClassMap,
      formatDate,
      formatDateTime,
      formatAmount,
    };
  },
});

export default SisahygoInformation;
